import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";

export const StyledItemGraph = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: `1px solid ${theme.palette.primary["300"]}`,
  borderRadius: "18px",
  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.4)",
}));
